import axios from 'axios';

const useQuotation = () => {
    const getQuotation = async (quotationId) => {
        const response = await axios.get('/quotations/' + quotationId);
        return response.data;
    };

    const getPayment = async (quotationId) => {
        const response = await axios.get('/quotations/' + quotationId + '/payment');
        return response.data;
    };

    return {
        getQuotation,
        getPayment,
    };
};

export default useQuotation;
